// src/components/ScholarPage.jsx
import React, { useState } from "react";
import SearchBar from "./SearchBar";
import PublicationList from "./PublicationList";
import PublicationDetails from "./PublicationDetails.jsx";
import publicationsData from "./data/publications.json";
import "./Styles/ScholarPage.scss";

const ScholarPage = () => {
  const [filteredPublications, setFilteredPublications] = useState(
    publicationsData
  );
  const [selectedPublication, setSelectedPublication] = useState(null);

  const handleSearch = (query) => {
    const searchQuery = query.toLowerCase();
    const results = publicationsData.filter((pub) => {
      return (
        pub.title.toLowerCase().includes(searchQuery) ||
        pub.author.toLowerCase().includes(searchQuery) ||
        pub.publication_date.includes(searchQuery)
      );
    });
    setFilteredPublications(results);
  };

  const handleSelectPublication = (publication) => {
    setSelectedPublication(publication);
  };

  return (
    <main className="scholar-page">
      <header className="scholar-header">
        <h1>Academic Research</h1>
      </header>
      {!selectedPublication ? (
        <>
          <SearchBar onSearch={handleSearch} />
          <PublicationList
            publications={filteredPublications}
            onSelect={handleSelectPublication}
          />
        </>
      ) : (
        <PublicationDetails
          publication={selectedPublication}
          onBack={() => setSelectedPublication(null)}
        />
      )}
    </main>
  );
};

export default ScholarPage;
